<i18n src="@/lang/actions.json"></i18n>

<i18n>
    {
        "en": {
            "email": {
                "label": "Email",
                "placeholder": "Email"
            },
            "password": {
                "label": "Password",
                "placeholder": "Password"
            }
        },
        "ua": {
            "email": {
                "label": "Email",
                "placeholder": "Email"
            },
            "password": {
                "label": "Пароль",
                "placeholder": "Пароль"
            }
        },
        "ru": {
            "email": {
                "label": "Email",
                "placeholder": "Email"
            },
            "password": {
                "label": "Пароль",
                "placeholder": "Пароль"
            }
        }
    }
</i18n>

<template>
  <el-main>
    <el-row type="flex" justify="center" align="middle">
      <el-col :span="6">
        <component :is="require('../images/fk_logo').default" :size="100" />
      </el-col>
      <el-col :span="6">
        <el-form
          label-position="left"
          :model="formData"
          :rules="rules"
          ref="loginForm"
        >
          <el-form-item :label="$t('email.label')" prop="email">
            <el-input
              :placeholder="$t('email.placeholder')"
              v-model="formData.email"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('password.label')" prop="password">
            <el-input
              :placeholder="$t('password.placeholder')"
              show-password
              v-model="formData.password"
            ></el-input>
          </el-form-item>
          <el-form-item class="actions">
            <el-button type="primary" @click="login('loginForm')">{{
              $t("actions.login")
            }}</el-button>
            <el-button @click="registerClick">{{
              $t("actions.register")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--<ApolloQuery :query="require('../../graphql/users/users.graphql')" :variables="{count}">
            <template v-slot="{result:{loading, error, data}}" >
                <input v-model.number="count" :disables="loading"></input>
                <div v-if="data">
                    <div v-for="item in data.users.data" :key="item.id" v-text="item.id + ' -::- ' + item.name"></div>
                </div>
            </template>
        </ApolloQuery>-->
  </el-main>
</template>

<script>
import { mapState } from "vuex";
import gql from "graphql-tag";

export default {
  name: "user_login",
  data() {
    return {
      count: 2,
      formData: {
        email: "",
        password: ""
      },
      rules: {
        email: [
          {
            required: true,
            message: "Please input email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Please input correct email address",
            trigger: ["blur", "change"]
          }
        ],
        password: [
          {
            required: true,
            message: "Please input email",
            trigger: "blur"
          },
          {
            min: 6,
            message: `Length should be have min 6 characters`,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  created() {
    this.checkLogged(this.user);
  },
  watch: {
    user: {
      handler: function(n, o) {
        this.checkLogged(n);
      },
      deep: true
    }
  },
  methods: {
    checkLogged(user) {
      if (user.token) {
        this.$log(user);

        let name;
        let params;
        if ((name = this.$route.query.backto)) {
          params = this.$route.query.params;
          this.$router.replace({
            name: name,
            params: params ? JSON.parse(decodeURI(params)) : null
          });
        } else {
          this.$router.replace({ name: "home" });
        }
      }
    },
    login(formName) {
      this.$log("CLICK Login");
      this.$refs[formName].validate(valid => {
        if (!valid) {
          this.$log("error submit!!");
          return false;
        }
        this.apolloLogin();
      });
    },
    apolloLogin() {
      this.$api
        .mutate({
          mutation: require("../../graphql/users/login.graphql"),
          variables: this.formData
        })
        .then(data => {
          this.$log("Done upvoting.");
          this.$log(this.$store);
        })
        .catch(error => {
          this.$log(error);
        });
    },
    registerClick() {
      this.$router.replace({ name: "register" });
    }
  },
  computed: mapState(["user"])
};
</script>

<style scoped lang="stylus">
.el-main {
    background-color: #162b3a;

    .el-row {
        height: 100%;
        flex-direction: column;
    }
}
</style>

<style lang="stylus">
.actions .el-form-item__content {
    display: flex
    .el-button {
        flex: 1 1
    }
}
</style>
